export type VersionNumber = {
    major: number;
    incremental: number;
    createdAt: string;
};

export const APP_VERSION: VersionNumber = {
    major: 2,
    incremental: 74,
    createdAt: '2026-07-24 14:08',
};

const buildTimeFromEnvironment = process.env.REACT_APP_BUILD_TIME;

export const BUILD_TIME: string = buildTimeFromEnvironment && buildTimeFromEnvironment.trim().length > 0
    ? buildTimeFromEnvironment
    : 'local';

export const PAGE_VERSIONS = {
    home: { major: 2, incremental: 1, createdAt: '2026-07-15 23:29' },
    search: { major: 2, incremental: 0, createdAt: '2026-06-24 17:10' },
    menu: { major: 2, incremental: 37, createdAt: '2026-07-22 23:13' },
    orders: { major: 2, incremental: 0, createdAt: '2026-06-24 17:10' },
    menuEditing: { major: 2, incremental: 20, createdAt: '2026-07-24 14:08' },
    foodMakersStatus: { major: 2, incremental: 4, createdAt: '2026-07-23 11:30' },
    productEditing: { major: 2, incremental: 8, createdAt: '2026-07-21 13:45' },
    rootRedirect: { major: 2, incremental: 0, createdAt: '2026-06-24 17:10' },
    unknown: { major: 2, incremental: 0, createdAt: '2026-06-24 17:10' },
} satisfies Record<string, VersionNumber>;

const ROUTE_VERSION_KEYS: Array<{ path: string; pageKey: keyof typeof PAGE_VERSIONS }> = [
    { path: '/Home', pageKey: 'home' },
    { path: '/Search', pageKey: 'search' },
    { path: '/Menu', pageKey: 'menu' },
    { path: '/menu', pageKey: 'menu' },
    { path: '/orders', pageKey: 'orders' },
    { path: '/MenuEditing', pageKey: 'menuEditing' },
    { path: '/ProductEditing', pageKey: 'productEditing' },
    { path: '/FoodMakersStatus', pageKey: 'foodMakersStatus' },
    { path: '/', pageKey: 'rootRedirect' },
];

export function formatVersion(version: VersionNumber): string {
    return `${version.major}.${version.incremental}`;
}

export function getPageVersionForPath(pathname: string): VersionNumber {
    const normalizedPath = pathname.endsWith('/') && pathname !== '/'
        ? pathname.slice(0, -1)
        : pathname;
    const matchedRoute = ROUTE_VERSION_KEYS.find((routeVersion) => routeVersion.path === normalizedPath);

    return matchedRoute ? PAGE_VERSIONS[matchedRoute.pageKey] : PAGE_VERSIONS.unknown;
}
